module.exports = __webpack_public_path__ + "fonts/Inter-200-latin-ext34.1ad231a.woff2";